import { createFileRoute } from "@tanstack/react-router";
import { ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { GoldCountryHubPage } from "@/components/gold-hub/GoldCountryHubPage";

const CANONICAL = "https://drhint.com/pakistan";
const TITLE =
  "Gold Rate in Pakistan Today — 24K, 22K, 21K, 18K Price Per Tola, 10 Gram & 1 Gram";
const DESCRIPTION =
  "Live gold price in Pakistan — per tola, per 10 gram and per gram for 24K, 22K, 21K and 18K. Recalculated every 10 minutes from international spot and interbank USD/PKR.";

export const Route = createFileRoute("/pakistan/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "index,follow,max-snippet:-1,max-image-preview:large" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: CANONICAL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_PK" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
      { rel: "alternate", hreflang: "en-PK", href: CANONICAL },
      { rel: "alternate", hreflang: "ur-PK", href: "https://drhint.com/pakistan/urdu" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://drhint.com/" },
            { "@type": "ListItem", position: 2, name: "Gold Rate Pakistan", item: CANONICAL },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": `${CANONICAL}#webpage`,
          url: CANONICAL,
          name: TITLE,
          description: DESCRIPTION,
          inLanguage: "en-PK",
          isPartOf: { "@id": "https://drhint.com/#website" },
        }),
      },
    ],
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("pakistan"));
  },
  component: () => <GoldCountryHubPage country="pakistan" />,
});